export default __webpack_public_path__ + "static/track-breaks-f4370135db55c067764e66ac9111f8c6.png";